import { render, staticRenderFns } from "./CalendarMonteMainBeta.vue?vue&type=template&id=13df883f&scoped=true&"
import script from "./CalendarMonteMainBeta.vue?vue&type=script&lang=js&"
export * from "./CalendarMonteMainBeta.vue?vue&type=script&lang=js&"
import style0 from "./CalendarMonteMainBeta.vue?vue&type=style&index=0&id=13df883f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df883f",
  null
  
)

export default component.exports